// extracted by mini-css-extract-plugin
module.exports = {"paper":"Paper_paper__ftVQ8","elevation0":"Paper_elevation-0__Y6tIV","elevation1":"Paper_elevation-1__DPQG3","withHover":"Paper_withHover__K_zWd"};